module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/components/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/components/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__("styled-components");
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// CONCATENATED MODULE: ./src/components/loadingSpinner/styles/index.ts

var Wrapper = external_styled_components_default.a.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1hihz2p-0"
})(["z-index:", ";background-color:", ";top:", ";left:", ";position:", ";width:", ";height:", ";padding-top:", "px;display:flex;padding:0;align-items:center;justify-content:center;"], function (props) {
  return props.isFullScreen ? '100' : 'inherit';
}, function (props) {
  return props.isFullScreen ? 'rgba(255, 255, 255, 0.5)' : 'transparent';
}, function (props) {
  return props.isFullScreen ? '0' : 'inherit';
}, function (props) {
  return props.isFullScreen ? '0' : 'inherit';
}, function (props) {
  return props.isFullScreen ? 'fixed' : 'inherit';
}, function (props) {
  return props.isFullScreen ? '100vw' : '100%';
}, function (props) {
  return props.isFullScreen ? '100vh' : 'inherit';
}, function (props) {
  return props.hasPaddingTop ? 100 : 0;
});
var LoaderWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "LoaderWrapper",
  componentId: "sc-1hihz2p-1"
})(["position:relative;width:100px;z-index:701;opacity:1;&:before{content:'';display:block;padding-top:100%;}"]);
var wink = Object(external_styled_components_["keyframes"])(["from{opacity:0;}to{opacity:1;}"]);
var rotate = Object(external_styled_components_["keyframes"])(["100%{transform:rotate(360deg);}"]);
var dash = Object(external_styled_components_["keyframes"])(["0%{stroke-dasharray:1,200;stroke-dashoffset:0;}50%{stroke-dasharray:89,200;stroke-dashoffset:-35px;}100%{stroke-dasharray:89,200;stroke-dashoffset:-124px;}"]);

var styles_color = function color(props) {
  return Object(external_styled_components_["keyframes"])(["100%,0%{stroke:", ";}40%{stroke:", ";}66%{stroke:", ";}80%,90%{stroke:#f1a426;}"], props.theme.carvana.blue.medium, props.theme.carvana.blue.dark, props.theme.carvana.blue.primary);
};

var CarIcon = external_styled_components_default.a.svg.withConfig({
  displayName: "CarIcon",
  componentId: "sc-1hihz2p-2"
})(["width:", "px;height:", "px;color:", ";fill:", ";position:absolute;top:", "%;left:", "%;animation:", " 1.25s ease-in-out infinite alternate;z-index:701;"], function (props) {
  return props.isLarge ? 29 : 22;
}, function (props) {
  return props.isLarge ? 29 : 22;
}, function (props) {
  return props.theme.carvana.blue.medium;
}, function (props) {
  return props.theme.carvana.blue.medium;
}, function (props) {
  return props.isLarge ? 35 : 39;
}, function (props) {
  return props.isLarge ? 35 : 39;
}, wink);
var AnimatedCircle = external_styled_components_default.a.svg.withConfig({
  displayName: "AnimatedCircle",
  componentId: "sc-1hihz2p-3"
})(["width:", "%;height:", "%;position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;animation:", " 2s linear infinite;z-index:701;& > circle{stroke-dasharray:1,200;stroke-dashoffset:0;animation:", " 1.5s ease-in-out infinite,", " 6s ease-in-out infinite;stroke-linecap:round;}"], function (props) {
  return props.isLarge ? 100 : 70;
}, function (props) {
  return props.isLarge ? 100 : 70;
}, rotate, dash, function (props) {
  return styles_color(props);
});
var ballClipRotate = Object(external_styled_components_["keyframes"])(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var AnimatedCircleIEFallback = external_styled_components_default.a.div.withConfig({
  displayName: "AnimatedCircleIEFallback",
  componentId: "sc-1hihz2p-4"
})(["@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){width:", "px;height:", "px;color:", ";position:absolute;top:0;right:0;bottom:0;left:0;margin:auto;&:after{content:'';width:100%;height:100%;display:inline-block;border:2px solid ", ";border-bottom-color:transparent;border-radius:50%;background:transparent;animation:", " 0.75s linear infinite;}}"], function (props) {
  return props.isLarge ? 100 : 70;
}, function (props) {
  return props.isLarge ? 100 : 70;
}, function (props) {
  return props.theme.carvana.blue.primary;
}, function (props) {
  return props.theme.carvana.blue.primary;
}, ballClipRotate);

// CONCATENATED MODULE: ./src/components/loadingSpinner/LoadingSpinner.tsx



var LoadingSpinner_LoadingSpinner = function LoadingSpinner(_ref) {
  var _ref$isLarge = _ref.isLarge,
      isLarge = _ref$isLarge === void 0 ? false : _ref$isLarge,
      _ref$hasPaddingTop = _ref.hasPaddingTop,
      hasPaddingTop = _ref$hasPaddingTop === void 0 ? false : _ref$hasPaddingTop,
      _ref$isFullScreen = _ref.isFullScreen,
      isFullScreen = _ref$isFullScreen === void 0 ? false : _ref$isFullScreen,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'spinnerWrapper' : _ref$className;
  return external_react_default.a.createElement(Wrapper, {
    hasPaddingTop: hasPaddingTop,
    isFullScreen: isFullScreen,
    className: className
  }, external_react_default.a.createElement(LoaderWrapper, null, external_react_default.a.createElement(CarIcon, {
    isLarge: isLarge,
    viewBox: isLarge ? '0 0 29 29' : '0 0 22 22'
  }, isLarge ? external_react_default.a.createElement("g", null, external_react_default.a.createElement("path", {
    d: "M14.5,2.25c5.4,0,6.24,1,6.27,1h0s-.84,1.07-6.27,1.07-6.24-1-6.27-1h0s.84-1.07,6.27-1.07M14.5,0C9.82,0,6,.73,6,3.31s3.82,3.3,8.5,3.3S23,5.88,23,3.31,19.18,0,14.5,0Z"
  }), external_react_default.a.createElement("path", {
    d: "M28,17H26.17l-2.12-5.11A3.67,3.67,0,0,0,20.84,10H8.16A3.67,3.67,0,0,0,5,11.89L2.83,17H1a1,1,0,0,0,0,2H2v9a1,1,0,0,0,1,1H5a1,1,0,0,0,1-1V27H23v1a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1V19h1a1,1,0,0,0,0-2ZM6.75,12.78A1.66,1.66,0,0,1,8.16,12H20.84a1.66,1.66,0,0,1,1.41.78L24,17H5ZM25,25H4V19H25Z"
  }), external_react_default.a.createElement("path", {
    d: "M8,23h2a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Z"
  }), external_react_default.a.createElement("path", {
    d: "M19,23h2a1,1,0,0,0,0-2H19a1,1,0,0,0,0,2Z"
  })) : external_react_default.a.createElement("g", null, external_react_default.a.createElement("path", {
    d: "M11,1.5c4.92,0,5.49,1,5.5,1v.06s-.58,1-5.5,1-5.49-1-5.5-1V2.47s.58-1,5.5-1M11,0C7.14,0,4,.56,4,2.5S7.14,5,11,5s7-.56,7-2.5S14.86,0,11,0Z"
  }), external_react_default.a.createElement("path", {
    d: "M14.84,9a1.67,1.67,0,0,1,1.44.82L17.81,13H4.19L5.72,9.82A1.67,1.67,0,0,1,7.16,9h7.68m0-2H7.16A3.67,3.67,0,0,0,4,8.89L2,13H1a1,1,0,0,0,0,2v6H1a1,1,0,0,0,1,1H4a1,1,0,0,0,1-1H17a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1h0V15a1,1,0,0,0,0-2H20l-2-4.11A3.67,3.67,0,0,0,14.84,7ZM3,19V15H19v4H3Z"
  }), external_react_default.a.createElement("path", {
    d: "M7,16H6a1,1,0,0,0,0,2H7a1,1,0,0,0,0-2Z"
  }), external_react_default.a.createElement("path", {
    d: "M16,16H15a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  }))), external_react_default.a.createElement(AnimatedCircle, {
    isLarge: isLarge,
    viewBox: "25 25 50 50"
  }, external_react_default.a.createElement("circle", {
    className: "path",
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    strokeWidth: "1.5",
    strokeMiterlimit: "10"
  })), external_react_default.a.createElement(AnimatedCircleIEFallback, {
    isLarge: isLarge
  })));
};

/* harmony default export */ var loadingSpinner_LoadingSpinner = (LoadingSpinner_LoadingSpinner);
// CONCATENATED MODULE: ./src/components/index.ts
/* concated harmony reexport LoadingSpinner */__webpack_require__.d(__webpack_exports__, "LoadingSpinner", function() { return loadingSpinner_LoadingSpinner; });
/* concated harmony reexport CarIcon */__webpack_require__.d(__webpack_exports__, "CarIcon", function() { return CarIcon; });
/* concated harmony reexport AnimatedCircle */__webpack_require__.d(__webpack_exports__, "AnimatedCircle", function() { return AnimatedCircle; });
/* concated harmony reexport AnimatedCircleIEFallback */__webpack_require__.d(__webpack_exports__, "AnimatedCircleIEFallback", function() { return AnimatedCircleIEFallback; });



/* harmony default export */ var components = __webpack_exports__["default"] = (loadingSpinner_LoadingSpinner);

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "styled-components":
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map